import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-06f61c7a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "top",
  id: "content"
};
var _hoisted_2 = ["src"];

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "banner_title"
  }, [/*#__PURE__*/_createTextVNode(" 百城愿景 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 成为一流的儿童健康阅读服务商 ")], -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "banner_abs"
  }, " BECOME A FIRST-CLASS CHILDREN'S READING HEALTH SERVICE PROVIDER.I HOPE EVERY CHILD WILL LOVE READING ", -1);
});

var _hoisted_5 = {
  style: {
    "width": "100vw",
    "background": "#fff",
    "overflow": "hidden"
  }
};
var _hoisted_6 = {
  class: "content"
};
var _hoisted_7 = {
  class: "content_title"
};
var _hoisted_8 = {
  class: "content_detail"
};
var _hoisted_9 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_carousel_item = _resolveComponent("el-carousel-item");

  var _component_el_carousel = _resolveComponent("el-carousel");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_carousel, {
    interval: 5000,
    loop: "true"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerList, function (item) {
        return _openBlock(), _createBlock(_component_el_carousel_item, {
          key: item
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("img", {
              src: item.url,
              class: "banner"
            }, null, 8, _hoisted_2), _hoisted_3, _hoisted_4];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.dataList.news_title), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
    innerHTML: _ctx.dataList.content,
    style: {
      "font-size": "13px",
      "font-weight": "400"
    }
  }, null, 8, _hoisted_9)])])])], 64);
}